import React from "react";

class ImgCard extends React.Component {
  state = { hide: 0 };
  Del = e => {
    this.props.clickDeleteImg();
    this.setState({
      hide: 1
    });
  };

  fotoDescricao = e => {
    this.props.changeDescricao(e);
  };

  render() {
    return (
      <React.Fragment>
        {this.state.hide === 0 && (
          <div className="card w-60 card_image">
           {!this.props.disabledClose && (
            <div>
              <span className="float_right">
                <button
                  type="button"
                  className="btn btn-danger btn_x"
                  onClick={this.Del}
                >
                  X
                </button>
              </span>
            </div>
           )}
            <img src={this.props.src} width="100%" alt="card" />
            <input
              className="form-control mt-2"
              onChange={e => this.fotoDescricao(e)}
              name={this.props.fieldName}
              id={this.props.idName}
              defaultValue={this.props.description}
            />
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default ImgCard;
